import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Spinner,
  Switch,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import { get } from "lodash";
import { Controller, useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";

export const SwitchField = ({
  field,
  onSwitchChange,
  leftLabel,
  rightLabel,
  centerLabel,
  isLoading,
}: {
  field: any;
  onSwitchChange?: (val: boolean) => void;
  leftLabel?: string;
  rightLabel?: string;
  centerLabel?: string;
  isLoading?: boolean;
}) => {
  const form = useFormContext();
  const {
    formState: { errors },
    control,
  } = form;
  const intl = useIntl();

  return (
    <Controller
      name={field.id}
      control={control}
      defaultValue={field.defaultValue || false}
      rules={field.validation?.required}
      render={({ field: { onChange, value } }) => (
        <FormControl
          isInvalid={!!get(errors, field.id)}
          isRequired={field.label && field.validation?.required}
        >
          <VStack alignItems={"flex-start"} gap={0}>
            {field.label && (
              <Tooltip
                label={
                  field.tooltipId &&
                  intl.formatMessage({
                    id: field.tooltipId,
                  })
                }
              >
                <FormLabel htmlFor={field.id}>{field.label}</FormLabel>
              </Tooltip>
            )}
            <HStack>
              {leftLabel && <Text>{leftLabel}</Text>}
              <Switch
                id={field.id}
                name={field.id}
                key={field.id}
                isChecked={value}
                isDisabled={field.isDisabled}
                onChange={(val) => {
                  onChange(val);
                  if (onSwitchChange) {
                    onSwitchChange(!!val);
                  }
                }}
              />
              {centerLabel && <Text fontSize={"sm"}>{centerLabel}</Text>}

              <Spinner
                size="sm"
                color="primary"
                display={isLoading ? "block" : "none"}
              />
              {rightLabel && <Text>{rightLabel}</Text>}
            </HStack>
          </VStack>
          <FormErrorMessage>
            <>{get(errors, field.id) && get(errors, `${field.id}.message`)}</>
          </FormErrorMessage>
        </FormControl>
      )}
    />
  );
};
